import React, { useState } from "react";
import "../styles/SpinButton.css"

export function SpinButton({ onClick }: { onClick: () => void }) {
   const [pressed, setPressed] = useState(false);
   const base = process.env.PUBLIC_URL || "";

   return (
      <img
         src={
            pressed
               ? `${base}/images/rmt/button-pressed.png`
               : `${base}/images/rmt/button-not-pressed.png`
         }
         alt="Spin Button"

         className={"spin-button"}
         draggable={false}
         onMouseDown={() => setPressed(true)}
         onMouseUp={() => {
            setPressed(false);
            onClick();
         }}
         onMouseLeave={() => setPressed(false)}
         onTouchStart={() => setPressed(true)}
         onTouchEnd={() => {
            setPressed(false);
            onClick();
         }}
      />
   );
}